import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";
import { roleForPath, getToken, saveToken, clearToken } from "../lib/authStorage";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out

  useEffect(() => {
    const role = roleForPath(window.location.pathname);
    const token = getToken(role);
    if (!role || !token) {
      setUser(false);
      return;
    }
    api.get("/auth/me")
      .then((res) => {
        if (res.data.role !== role) {
          clearToken(role);
          setUser(false);
          return;
        }
        setUser(res.data);
      })
      .catch(() => {
        clearToken(role);
        setUser(false);
      });
  }, []);

  const saveSession = useCallback((data) => {
    saveToken(data.user.role, data.token);
    setUser(data.user);
  }, []);

  const logout = useCallback(() => {
    const role = (user && user.role) || roleForPath(window.location.pathname);
    clearToken(role);
    setUser(false);
  }, [user]);

  return (
    <AuthContext.Provider value={{ user, saveSession, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
